import axios from 'axios';

export default {
  state: {
    historybuy: [],
    section: {},
    historybuyLoading: false,
    historybuyError: null,
    historybuyLoaded: false,
    noMoreHistoryBuy: false
  },
  mutations: {
    SET_HISTORYBUY(state, {historybuy, page}) {
      if (page > 1) {
        state.historybuy = state.historybuy.concat(historybuy.data.items);
      }
      else
        state.historybuy = historybuy.data.items;
      if (!historybuy.data?.pagination?.has_next)
        state.noMoreHistoryBuy = true;
      state.historybuyLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_HISTORYBUY_LOADING(state, status) {
      state.historybuyLoading = status;
    },
    SET_HISTORYBUY_ERROR(state, error) {
      state.historybuyError = error;
    },
    UNSET_HISTORYBUY(state) {
      state.historybuyLoaded = false;
      state.historybuyLoading = false;
      state.historybuy = [];
      state.noMoreHistoryBuy = false;
    },
  },
  actions: {
    async fetchHistoryBuy({ commit, state }, {page}) {
      if (page == 1)
        commit('UNSET_HISTORYBUY');

      try {
        commit('SET_HISTORYBUY_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/historybuy/', {
          params: {
            page: page
          }
        });
        commit('SET_HISTORYBUY', {historybuy:response.data, page:page});
        commit('SET_HISTORYBUY_ERROR', null);
      } catch (error) {
        commit('SET_HISTORYBUY_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching historybuy:', error);
      } finally {
        commit('SET_HISTORYBUY_LOADING', false);
      }
    }
  },
  getters: {
    historybuy: state => state.historybuy,
    historybuyLoading: state => state.historybuyLoading,
    historybuyError: state => state.historybuyError,
    historybuyLoaded: state => state.historybuyLoaded,
    noMoreHistoryBuy: state => state.noMoreHistoryBuy
  }
}